export default "__VITE_ASSET__740513d5__"